module.exports = __webpack_public_path__ + "ac3477dbf6fcbb9282ec88ca1f4650d4.png";